import React, { Component } from 'react';
import{
    Container,
    Row,
    Col,
    Button,
    Table
} from 'reactstrap';
/**
 * Used for the Listino Prezzi section. 
 */
export class UtentiList extends Component {

    constructor(props) {
        super(props);

        this.state = {
                 
        };
    
    }

    handleDelete = (utente) => {

    }


    /**
     * Renders the page
     */
    render() {
        return (
            <Container className="d-flex align-items-center" fluid>
                <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                    <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                        <Table responsive borderless style={{margin: "0", marginTop: "5px", fontSize: "20px"}}>
                            <thead>
                                <tr>
                                    <th style={{padding: "0", width: "7%", textAlign: "center"}}></th>
                                    <th style={{padding: "0", textAlign: "center"}}>Nome Utente</th>
                                    <th style={{padding: "0", textAlign: "center"}}>Email</th>
                                    <th style={{padding: "0", textAlign: "center"}}>Nome</th>
                                    <th style={{padding: "0", textAlign: "center"}}>Cognome</th>
                                    <th style={{padding: "0", textAlign: "center"}}>Ruoli</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.utenti.map((utente, index) => {
                                    return(
                                        <tr key={index}>
                                            <td align="center" style={{padding: "0", width: "7%"}}>
                                                <Button type="submit" 
                                                    onClick={() => this.props.handleDelete(utente, index)}
                                                    style={{
                                                        width: "35%", 
                                                        padding: "0px", 
                                                        color: "#011e41", 
                                                        border: "none", 
                                                        backgroundColor: "transparent", 
                                                        marginLeft: "5px", 
                                                        marginRight: "5px"}}
                                                >
                                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                                </Button> 
                                                <Button type="submit" 
                                                    onClick={() => this.props.editFun(utente)}
                                                    style={{
                                                        width: "35%", 
                                                        padding: "0px", 
                                                        color: "#011e41", 
                                                        border: "none", 
                                                        backgroundColor: "transparent", 
                                                        marginLeft: "5px", 
                                                        marginRight: "10px"}}
                                                >
                                                    <i className="fa fa-pencil" aria-hidden="true"></i>
                                                </Button> 
                                            </td>
                                            <td align="center" style={{padding: "0"}}>{utente.userName}</td>
                                            <td align="center" style={{padding: "0"}}>{utente.email}</td>
                                            <td align="center" style={{padding: "0"}}>{utente.nome}</td>
                                            <td align="center" style={{padding: "0"}}>{utente.cognome}</td>
                                            <td align="center" style={{padding: "0"}}>
                                                {utente.roles.map((role, index) => {
                                                    return (index + 1) === utente.roles.length ? role : `${role}/`
                                                })}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>                                    
                    </Col>
                </Row> 
            </Container>                                            
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Utenti/UtentiList.js